const funcion = {
    ObtenPersonasDeSIAP: "SICUS/Funciones/ObtenPersonasDeSIAP"
}

export default funcion


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICUS/funcion/funcion.js
// module id = null
// module chunks = 